
enum IconType {
    Leading = 'leading',
    Trailing = 'trailing',
}

export default IconType
